import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailAttachmentsComponent } from './email-attachments.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    EmailAttachmentsComponent
  ],
  exports: [
    EmailAttachmentsComponent
  ]
})
export class EmailAttachmentsModule {}
